/**
 * MainOppsCreatedTile — Opps Created tile for the /main dashboard (2026-07-22, John).
 *
 * Renders the EXACT same tile as the CRO dashboard's "Opps Created (trailing 90
 * days)" — it reuses CroOppsCreatedTile verbatim — but sources its data from the
 * SF-OAuth `/api/main/opps-created` endpoint (useMainOppsCreated) so it works on
 * the apex host. This thin wrapper exists so the hook lives inside a real
 * component (MainTileSection.renderTile is a plain function, not a component, so
 * it can't call hooks). MainTileSection special-cases MAIN-03 → <MainOppsCreatedTile/>.
 */
import { useMainOppsCreated } from '../../queries/useMainOppsCreated.js';
import { CroOppsCreatedTile } from '../CroOppsCreatedTile.js';

export function MainOppsCreatedTile(): React.JSX.Element {
  const { data, isLoading, isError, error, refetch } = useMainOppsCreated();
  return (
    <CroOppsCreatedTile
      data={data}
      isLoading={isLoading}
      isError={isError}
      error={error}
      refetch={() => {
        void refetch();
      }}
    />
  );
}
